module.exports = __webpack_public_path__ + "static/img/Tom-Gross.0c146f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Gross.jpg
// module id = NZq9
// module chunks = 0